import { CommonModule } from '@angular/common';
import { Directive, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[dateParser]',
  standalone: true,
})
export class DateParserDirective implements OnInit {
  @Input('dateParser') dateParser?: string;

  constructor(private ngControl: NgControl) {}

  ngOnInit() {
    if (this.ngControl.control) {
      this.setValue(this.ngControl.control.value);
      this.ngControl.control.valueChanges.subscribe((value) => {
        this.setValue(value);
      });
    }
  }

  private setValue(value: string | Date) {
    if (!this.ngControl || !this.ngControl.control) {
      return;
    }

    if (value instanceof Date) {
      if (!isNaN(value.getTime())) {
        const localDateValue = new Date(value.getFullYear(), value.getMonth(), value.getDate());
        this.ngControl.control.setValue(localDateValue, { emitEvent: false });
      }
      return;
    }

    if (typeof value !== 'string') {
      return;
    }

    const raw = value.trim();
    if (!raw) {
      return;
    }

    const isoDateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoDateOnly) {
      const year = Number(isoDateOnly[1]);
      const month = Number(isoDateOnly[2]);
      const day = Number(isoDateOnly[3]);
      const localDateValue = new Date(year, month - 1, day);
      if (!isNaN(localDateValue.getTime())) {
        this.ngControl.control.setValue(localDateValue, { emitEvent: false });
      }
      return;
    }

    const cleanedValue = raw.endsWith('Z') ? raw.slice(0, -1) : raw;
    const utcDateValue = new Date(cleanedValue);
    if (isNaN(utcDateValue.getTime())) {
      return;
    }
    const localDateValue = new Date(utcDateValue.getFullYear(), utcDateValue.getMonth(), utcDateValue.getDate());
    this.ngControl.control.setValue(localDateValue, { emitEvent: false });
  }
}
